(() => {
  const initializeNavigation = () => {
    const header = document.querySelector('[data-site-header]');
    const navigation = document.querySelector('[data-site-navigation]');
    const toggle = document.querySelector('[data-navigation-toggle]');
    const close = document.querySelector('[data-navigation-close]');

    if (!header || !navigation || !toggle) {
      return;
    }

    const utilityLinks = header.querySelectorAll('.site-header__search, [data-cart-toggle]');
    const drawerQuery = window.matchMedia('(max-width: 767px)');
    let lastFocusedElement = null;

    const setNavigationState = (isOpen, options = {}) => {
      const { moveFocus = false, returnFocus = false } = options;

      if (!drawerQuery.matches) {
        navigation.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('prospect-navigation-open');
        return;
      }

      navigation.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('prospect-navigation-open', isOpen);

      if (isOpen && moveFocus) {
        const focusTarget = close || navigation.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
        focusTarget?.focus();
      }

      if (!isOpen && returnFocus && lastFocusedElement) {
        lastFocusedElement.focus();
      }
    };

    document.documentElement.classList.add('prospect-navigation-ready');
    setNavigationState(false);

    toggle.addEventListener('click', () => {
      if (!drawerQuery.matches) {
        return;
      }

      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      lastFocusedElement = toggle;
      setNavigationState(!isOpen, { moveFocus: !isOpen, returnFocus: isOpen });
    });

    if (close) {
      close.addEventListener('click', () => setNavigationState(false, { returnFocus: true }));
    }

    navigation.addEventListener('click', (event) => {
      if (event.target.closest('a') && drawerQuery.matches) {
        setNavigationState(false);
      }
    });

    utilityLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (drawerQuery.matches && !navigation.hidden) {
          setNavigationState(false);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawerQuery.matches && !navigation.hidden) {
        setNavigationState(false, { returnFocus: true });
      }
    });

    document.addEventListener('click', (event) => {
      if (!drawerQuery.matches || navigation.hidden) {
        return;
      }

      if (!header.contains(event.target)) {
        setNavigationState(false, { returnFocus: true });
      }
    });

    const handleViewportChange = () => setNavigationState(false);
    if (typeof drawerQuery.addEventListener === 'function') {
      drawerQuery.addEventListener('change', handleViewportChange);
    } else {
      drawerQuery.addListener(handleViewportChange);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeNavigation, { once: true });
  } else {
    initializeNavigation();
  }
})();
